import { NextPageContext } from 'next';
import getConfig from 'next/config';

import ListCollection from 'types/redux/ListCollection';
import { Routes } from 'types/routes';

import Article, { Roles } from 'models/Article';
import Job from 'models/Job';
import JobCity from 'models/JobCity';

import { withVariables } from 'utils/string';

import { list as listArticles } from 'requests/articles';
import { list as listJobs, single } from 'requests/jobs';

import Component from './component';
import { Props } from './types';

Component.getInitialProps = async (appContext: NextPageContext): Promise<Props> => {
    let job: Job = null;
    let query: string | string[] = null;
    let jobCity: JobCity = null;
    let jobs: ListCollection<Job> = null;
    let articles: ListCollection<Article> = null;
    const { publicRuntimeConfig } = getConfig();
    try {
        await Promise.all([
            single({ slug: appContext?.query?.slug.toString() }),
            listJobs({ page: 1, perPage: 6 }),
            listArticles({ page: 1, perPage: 6, role: Roles.Worker }),
        ]).then(responses => {
            job = responses[0];
            jobs = responses[1];
            articles = responses[2];
            query = appContext.query.jobCitySlug;
            jobCity = job?.jobCities.find((jobCity) => jobCity.id === query);
        }).then(()=> {
            const oldJobCity = job?.jobCities.find((jobCity) => jobCity.city?.slug === query);
            if(oldJobCity) {
                appContext.res.writeHead(301, { location: withVariables(publicRuntimeConfig.APP_URL + Routes.PublicJob, { slug: job?.slug }, { jobCitySlug: oldJobCity?.id }) });
                appContext.res.end();
            }
        });
    } catch (error) {
        console.error(error);
        return {
            notFound: true,
        };
    }

    return {
        job,
        jobCity,
        jobs: jobs.elements || [],
        articles: articles.elements || [],
    };
};

export default Component;
